import React, { Component } from 'react'
import { plain } from 'format-json'
import { URL_WRAPPING_CRYPTO_KEY } from 'front-end-core/constants/urls'
import { crypto } from 'front-end-core/helpers/webcrypto'

export default class Crypto extends Component {
  state = {
    publicJWK: '',
    privateJWK: '',
    publicPEM: '',
    privatePEM: '',
    serverUrl: sessionStorage.getItem('serverUrl') || location.protocol + '//' + location.host + location.pathname + URL_WRAPPING_CRYPTO_KEY,
    message: '',
    keyFormat: sessionStorage.getItem('keyFormat') || 'pem'
  }

  handleUpdate (name, e) {
    this.setState({ [name]: e.target.value })
    sessionStorage.setItem(name, e.target.value)
  }

  handleOnClickGenerateKeys = () => {
    crypto.call('generateKeyPair')
      .then(({ publicJWK, privateJWK, publicPEM, privatePEM }) => this.setState({ publicJWK: plain(publicJWK), publicPEM, privatePEM, privateJWK: plain(privateJWK) }))
      .catch(e => console.error(e))
  }

  handleOnClickFetchKeys = () => {
    fetch(this.state.serverUrl)
      .then(resp => resp.json())
      .then(({ data: { ckek: { privateJWK, publicJWK } } }) => ({ privateJWK, publicJWK }))
      .then(({ publicJWK, privateJWK }) => this.setState({ publicJWK: plain(publicJWK), privateJWK: plain(privateJWK) }))
      .catch(e => console.error(e))
  }

  test (alg) {
    Promise.resolve({
      privateJWK: this.state.privateJWK,
      publicJWK: this.state.publicJWK,
      privatePEM: this.state.privatePEM,
      publicPEM: this.state.publicPEM
    })
      .then(key => crypto.call('testKeyPair', key, alg, this.state.keyFormat))
      .then(result => this.setState({ message: result ? 'It works!' : 'It failed :(' }))
      .catch(e => this.setState({ message: e.message }))
  }

  render () {
    return (
      <div className='utils-view'>
        <section className='bot-border-black section-heading'>
          Developer utils
        </section>
        <form onSubmit={e => e.preventDefault()}>
          <h3>RSA keys test</h3>
          <h4>Test format</h4>
          <select className='form-control' value={this.state.keyFormat} onChange={this.handleUpdate.bind(this, 'keyFormat')}>
            <option value='pem'>PEM</option>
            <option value='jwk'>JWK</option>
          </select>
          {this.state.keyFormat === 'jwk' && (
            <div>
              <h4>Public key JWK</h4>
              <textarea className='form-control' value={this.state.publicJWK} onChange={this.handleUpdate.bind(this, 'publicJWK')} />
              <h4>Private key JWK</h4>
              <textarea className='form-control' value={this.state.privateJWK} onChange={this.handleUpdate.bind(this, 'privateJWK')} />
              <h4>JWK key url</h4>
              <input className='form-control' type='text' value={this.state.serverUrl} onChange={this.handleUpdate.bind(this, 'serverUrl')} />
              <button className='btn btn-default' onClick={this.handleOnClickFetchKeys}>Fetch JWK keys</button>
            </div>
          )}
          {this.state.keyFormat === 'pem' && (
            <div>
              <h4>Public key PEM</h4>
              <textarea className='form-control' value={this.state.publicPEM} onChange={this.handleUpdate.bind(this, 'publicPEM')} />
              <h4>Private key PEM</h4>
              <textarea className='form-control' value={this.state.privatePEM} onChange={this.handleUpdate.bind(this, 'privatePEM')} />
            </div>
          )}
          <div className='btns'>
            <button className='btn btn-default' onClick={this.handleOnClickGenerateKeys}>Generate keys</button>
            <button className='btn btn-primary' onClick={this.test.bind(this, 'RSAES-PKCS1-V1_5')}>Test RSAES-PKCS1-V1_5</button>
            <button className='btn btn-primary' onClick={this.test.bind(this, 'RSA-OAEP')}>Test RSA-OAEP</button>
          </div>
          <h5 style={{ textAlign: 'center' }}>{this.state.message}</h5>
        </form>
      </div>
    )
  }
}
